<template>
  <div ref="rootRef" class="l3">
    <a class="skip" href="#main">Saltar al contenido</a>
    <div
      class="scroll-progress"
      :style="{ transform: 'scaleX(' + scrollProgress + ')' }"
      aria-hidden="true"
    ></div>
    <main id="main">
      <section class="hero wrap" aria-labelledby="hero-title">
        <div class="hero-copy">
          <div v-if="isCopyV2" class="eyebrow">Para profesionales y negocios de servicios</div>
          <div v-else class="eyebrow">Para quienes viven de lo que hacen</div>
          <h1 id="hero-title">
            No emprendiste para vivir haciendo <span class="accent">presupuestos.</span>
          </h1>
          <p v-if="isCopyV2">
            Prio reúne tus consultas, presupuestos y proyectos en una sola app. Prepará
            presupuestos con tus servicios y precios, compartilos con tu marca y seguí el trabajo
            sin buscar todo entre mensajes.
          </p>
          <p v-else>
            Empezaste por lo que amás — cocinar, decorar, fotografiar, guiar, diseñar. Hoy pasás más
            tiempo en WhatsApp que haciendo tu trabajo. Prio te devuelve ese tiempo: del primer hola
            al último pago, sin el caos.
          </p>
          <a class="cta" :href="SIGNUP_URL"
            >Probá gratis 30 días <span aria-hidden="true">↗</span>
          </a>
          <div class="guarantee">Sin tarjeta · Cancelás cuando quieras</div>
        </div>
        <div class="hero-art">
          <div class="scene" id="scene" :data-mode="mode">
            <div class="orbit" aria-hidden="true"></div>
            <span ref="sparkRef" class="spark" aria-hidden="true">✳</span>
            <div class="hero-note" aria-hidden="true">Bien a<br />tu manera.<span>↘</span></div>
            <div class="proposal-stack" :aria-hidden="mode === 'chaos'">
              <div class="proposal">
                <div class="proposal-head">
                  <span class="studio">casa olivia</span>
                  <span class="mini-tag">TU MARCA</span>
                </div>
                <h3>Presupuesto</h3>
                <p>PARA JULI · Nº B4R8T</p>
                <div class="row">
                  <span>Catering de cumpleaños</span>
                  <b>$ 480.000</b>
                </div>
                <div class="row">
                  <span>Mesa dulce</span>
                  <b>$ 85.000</b>
                </div>
                <div class="total">
                  <span>Total aprobado</span>
                  <strong>$ 565.000</strong>
                </div>
              </div>
            </div>
            <div class="accepted" :aria-hidden="mode === 'chaos'">
              <b>✓</b>Ese pequeño gran sí.<small>Presupuesto aprobado. Listo para coordinar.</small>
            </div>
            <div class="chats" :aria-hidden="mode !== 'chaos'">
              <div class="chat">
                Hola! ¿Me pasás precio para un cumple? Somos 40. ¿Incluye la mesa dulce?<small
                  >WhatsApp · 23:47</small
                >
              </div>
              <div class="chat">
                Te paso todo por acá: el menú, las opciones, lo de la vajilla…<small
                  >Un choclo de texto</small
                >
              </div>
              <div class="chat">
                Yo pensé que incluía la vajilla. ¿Cuánto queda al final?<small
                  >Otra vez, a explicar.</small
                >
              </div>
            </div>
          </div>
          <div class="scene-controls">
            <div class="segmented" role="group" aria-label="Comparar caos y orden">
              <button
                type="button"
                data-action="hero-mode"
                data-context="chaos"
                :aria-pressed="mode === 'chaos'"
                aria-controls="scene"
                @click="setMode('chaos')"
              >
                El caos
              </button>
              <button
                type="button"
                data-action="hero-mode"
                data-context="order"
                :aria-pressed="mode === 'order'"
                aria-controls="scene"
                @click="setMode('order')"
              >
                Con prio.
              </button>
            </div>
            <span class="mono">← PROBALO</span>
          </div>
          <p class="demo-note" style="text-align: center">
            Demo ilustrativa · Tu trabajo, con tu marca.
          </p>
        </div>
      </section>
      <div class="ribbon-shell">
        <div
          class="ribbon"
          :class="{ paused: marqueePaused }"
          aria-label="Para cocinar, decorar, fotografiar, guiar y diseñar"
        >
          <div class="marquee" aria-hidden="true">
            <div class="trade-set">
              cocinar <i>✳</i> decorar <i>✳</i> fotografiar <i>✳</i> guiar <i>✳</i> diseñar
              <i>✳</i> cocinar <i>✳</i> decorar <i>✳</i> fotografiar <i>✳</i> guiar <i>✳</i> diseñar
              <i>✳</i>
            </div>
            <div class="trade-set">
              cocinar <i>✳</i> decorar <i>✳</i> fotografiar <i>✳</i> guiar <i>✳</i> diseñar
              <i>✳</i> cocinar <i>✳</i> decorar <i>✳</i> fotografiar <i>✳</i> guiar <i>✳</i> diseñar
              <i>✳</i>
            </div>
          </div>
          <button
            class="pause"
            type="button"
            data-action="marquee-pause"
            :aria-pressed="marqueePaused"
            :aria-label="marqueePaused ? 'Reanudar movimiento' : 'Pausar movimiento'"
            @click="toggleMarquee"
          >
            {{ marqueePaused ? '▶' : 'Ⅱ' }}
          </button>
        </div>
      </div>
      <section class="section wrap" aria-labelledby="pain-title">
        <div class="eyebrow">Crecer no tendría que sentirse así</div>
        <div class="pain-heading reveal">
          <h2 id="pain-title">
            Un proceso improvisado te alcanza para el primer cliente.
            <span class="accent">¿Y para el número 40?</span>
          </h2>
          <div class="counter-block">
            <span ref="counterRef" class="counter" data-context="client-counter" aria-hidden="true"
              >40</span
            >
            <p>clientes.<br />Y una sola persona del otro lado: vos.</p>
          </div>
        </div>
        <div class="pain-grid">
          <article class="pain-card reveal">
            <div class="mono">01 / EL DÍA SIGUE</div>
            <h3>23:47 WhatsApp</h3>
            <p>
              Terminaste de trabajar. Pero todavía te quedan las consultas, los precios y los
              mensajes.
            </p>
          </article>
          <article class="pain-card reveal">
            <div class="mono">02 / TODO MEZCLADO</div>
            <h3>Un choclo de texto</h3>
            <p>Tu propuesta, perdida entre una nota de voz y un “después lo miro”.</p>
          </article>
          <article class="pain-card reveal">
            <div class="mono">03 / OTRA ACLARACIÓN</div>
            <h3>“Yo pensé que…”</h3>
            <p>
              “Yo pensé que incluía la vajilla.” Lo que no quedó claro vuelve como trabajo de más.
            </p>
          </article>
        </div>
        <p class="pain-end reveal">
          No es que te falte organización. Es que tu sistema es desorganizado.
        </p>
      </section>
      <section class="section flow-section" id="sistema" aria-labelledby="flow-title">
        <div class="wrap">
          <div class="eyebrow">Menos vueltas. Más hacer.</div>
          <div class="flow-heading reveal">
            <h2 id="flow-title">
              Cinco pasos.<br />
              <span>Un solo sistema.</span>
            </h2>
            <p>Un solo sistema para organizar el trabajo y mantener al cliente al tanto.</p>
          </div>
          <div class="story">
            <nav class="story-nav" aria-label="Los cinco pasos">
              <a
                href="#paso-1"
                data-action="story-nav"
                data-context="paso-1"
                :class="{ active: activeStep === 0 }"
                :aria-current="activeStep === 0 ? 'step' : undefined"
              >
                <span>01</span>Consultas</a
              >
              <a
                href="#paso-2"
                data-action="story-nav"
                data-context="paso-2"
                :class="{ active: activeStep === 1 }"
                :aria-current="activeStep === 1 ? 'step' : undefined"
              >
                <span>02</span>Presupuesto</a
              >
              <a
                href="#paso-3"
                data-action="story-nav"
                data-context="paso-3"
                :class="{ active: activeStep === 2 }"
                :aria-current="activeStep === 2 ? 'step' : undefined"
              >
                <span>03</span>Presentación</a
              >
              <a
                href="#paso-4"
                data-action="story-nav"
                data-context="paso-4"
                :class="{ active: activeStep === 3 }"
                :aria-current="activeStep === 3 ? 'step' : undefined"
              >
                <span>04</span>Aprobación</a
              >
              <a
                href="#paso-5"
                data-action="story-nav"
                data-context="paso-5"
                :class="{ active: activeStep === 4 }"
                :aria-current="activeStep === 4 ? 'step' : undefined"
              >
                <span>05</span>Proyecto</a
              >
            </nav>
            <div>
              <article class="step" id="paso-1">
                <div class="reveal">
                  <span class="step-num">01</span>
                  <h3 v-if="isCopyV2">Recibís la consulta</h3>
                  <h3 v-else>Consultas analizadas</h3>
                  <p v-if="isCopyV2">
                    Compartís tu link por WhatsApp, Instagram o donde te contacten. Las consultas
                    que llegan por ese formulario quedan organizadas en Prio, con hasta dos
                    preguntas aclaratorias si hacen falta.
                  </p>
                  <p v-else>
                    Tu link con tu marca trabaja 24/7. Tu cliente te cuenta qué necesita y Prio
                    organiza la información. Vos seguís con lo tuyo.
                  </p>
                  <router-link
                    class="deep-link"
                    :to="copyLink('/consultas')"
                    data-action="home-deep-dive"
                    data-context="consultas"
                    >Cómo entran las consultas <span aria-hidden="true">→</span></router-link
                  >
                </div>
                <div class="mock reveal">
                  <div class="mock-top">
                    <span>casa olivia / consultas</span>
                    <span class="status">Formulario público</span>
                  </div>
                  <div class="mock-title">Contame qué<br />tenés en mente.</div>
                  <div class="field"><small>NOMBRE</small>Juli</div>
                  <div class="field">
                    <small>CONTACTO · EMAIL O TELÉFONO</small>juli@example.com
                  </div>
                  <div class="field"><small>DIRECCIÓN · OPCIONAL</small>Sin completar</div>
                  <div class="field">
                    <small>¿QUÉ NECESITÁS?</small>Catering para 40 personas, el 24 de octubre al
                    mediodía.
                  </div>
                  <div class="demo-note">
                    Si hace falta, hasta dos preguntas abiertas. Responder es opcional.
                  </div>
                  <div class="mock-foot">✓ Consulta enviada · Ejemplo</div>
                </div>
              </article>
              <article class="step" id="paso-2">
                <div class="reveal">
                  <span class="step-num">02</span>
                  <h3 v-if="isCopyV2">Preparás el presupuesto</h3>
                  <h3 v-else>Ya tenés la base. Solo revisás.</h3>
                  <p v-if="isCopyV2">
                    La consulta se cruza con tu catálogo y tus presupuestos anteriores. Ya tenés
                    la base. Solo revisás: servicios, importes y condiciones antes de compartir.
                  </p>
                  <p v-else>
                    Después del envío, la IA analiza la consulta con tu catálogo y tus presupuestos
                    anteriores. Usás esa base para preparar el presupuesto y revisar servicios e
                    importes.
                  </p>
                  <router-link
                    class="deep-link"
                    :to="copyLink('/presupuestos')"
                    data-action="home-deep-dive"
                    data-context="presupuestos"
                    >Presupuestos que cierran ventas <span aria-hidden="true">→</span></router-link
                  >
                </div>
                <div class="mock reveal">
                  <div class="mock-top">
                    <span>Presupuesto para Juli</span>
                    <span class="status draft">Borrador</span>
                  </div>
                  <div class="mock-title">Una buena base.<br />Tu última palabra.</div>
                  <div class="catalog-line">
                    <span class="check">✓</span>Consulta de Juli analizada
                  </div>
                  <div class="catalog-line">
                    <span class="check">✓</span>Servicios e importes sugeridos
                  </div>
                  <div class="catalog-line">
                    <span class="check">✓</span>Notas y condiciones para revisar
                  </div>
                  <div class="mock-foot">Vista del profesional · Nada enviado al cliente</div>
                </div>
              </article>
              <article class="step" id="paso-3">
                <div class="reveal">
                  <span class="step-num">03</span>
                  <h3 v-if="isCopyV2">Lo compartís con tu marca</h3>
                  <h3 v-else>Presentás como un profesional.</h3>
                  <p>
                    Un link con tu marca, ítems claros, opcionales, validez y términos. Se ve
                    perfecto en celular. Tu trabajo, presentado como se merece.
                  </p>
                  <router-link
                    class="deep-link"
                    :to="copyLink('/presupuestos')"
                    data-action="home-deep-dive"
                    data-context="presupuestos"
                    >Probá la aprobación online <span aria-hidden="true">→</span></router-link
                  >
                </div>
                <div class="mock reveal">
                  <div class="mock-top">
                    <span>↗ casa olivia / propuesta</span>
                    <span class="mini-tag">VISTA CELULAR</span>
                  </div>
                  <div class="phone-preview">
                    <h4>Presupuesto</h4>
                    <p>Para Juli · Nº B4R8T</p>
                    <div class="row">
                      <span>Catering · 40 personas</span>
                      <b>Incluido</b>
                    </div>
                    <div class="row">
                      <span>Mesa dulce</span>
                      <b>Opcional</b>
                    </div>
                    <div class="demo-note">Válido por 15 días · Condiciones claras</div>
                  </div>
                </div>
              </article>
              <article class="step" id="paso-4">
                <div class="reveal">
                  <span class="step-num">04</span>
                  <h3 v-if="isCopyV2">Tu cliente lo aprueba</h3>
                  <h3 v-else>Aprobación online.</h3>
                  <p v-if="isCopyV2">
                    Tu cliente marca opcionales, ve el total y confirma la aprobación. Recibís un
                    aviso y el presupuesto queda aprobado. Consultá la actividad del presupuesto
                    para decidir cómo seguir.
                  </p>
                  <p v-else>
                    Tu cliente marca opcionales, ve el total y confirma la aprobación. Recibís un
                    aviso y el presupuesto queda aprobado. También podés consultar visitas
                    registradas, tiempo en pantalla y opciones seleccionadas.
                  </p>
                  <router-link
                    class="deep-link"
                    :to="copyLink('/presupuestos')"
                    data-action="home-deep-dive"
                    data-context="presupuestos"
                    ><template v-if="isCopyV2">Consultá la actividad del presupuesto</template
                    ><template v-else>Señales para saber cuándo llamar</template>
                    <span aria-hidden="true"> →</span></router-link
                  >
                </div>
                <div class="mock reveal">
                  <div class="mock-top">
                    <span>Armá tu propuesta</span>
                    <span class="status">Probalo acá</span>
                  </div>
                  <div class="row">
                    <span>Catering · 40 personas</span>
                    <b>$ 480.000</b>
                  </div>
                  <template v-for="opt in optionals" :key="opt.id">
                    <label v-if="!approved" class="optional">
                      <input
                        v-model="opt.on"
                        type="checkbox"
                        data-action="demo-optional"
                        :data-context="opt.id"
                        :data-input="'demo-optional-' + opt.id"
                        :aria-label="opt.name + ', ' + formatMoney(opt.price)"
                      />
                      <span>{{ opt.name }}</span>
                      <b>+ {{ formatMoney(opt.price) }}</b>
                    </label>
                    <div v-else-if="opt.on" class="row">
                      <span>{{ opt.name }}</span
                      ><b>{{ formatMoney(opt.price) }}</b>
                    </div>
                  </template>
                  <div class="total">
                    <span>Total</span>
                    <strong>
                      <output id="total" aria-live="polite" aria-atomic="true">{{
                        formattedTotal
                      }}</output>
                    </strong>
                  </div>
                  <button
                    ref="approveRef"
                    class="approve"
                    type="button"
                    :disabled="approved"
                    data-action="demo-approve"
                    @click="approvalDialogRef?.showModal()"
                  >
                    {{ approved ? '✓ Propuesta aprobada' : 'Probar aprobación ↗' }}
                  </button>
                  <dialog
                    ref="approvalDialogRef"
                    class="approval-dialog"
                    aria-labelledby="home-approval-title"
                  >
                    <h3 id="home-approval-title">¿Aprobar presupuesto?</h3>
                    <p>Total: {{ formattedTotal }}. Esta demo no envía ni guarda nada.</p>
                    <form method="dialog">
                      <button class="small-button" autofocus data-action="demo-cancel">
                        Cancelar
                      </button>
                      <button
                        class="approve"
                        type="button"
                        data-action="demo-confirm"
                        @click="approveDemo"
                      >
                        Confirmar aprobación
                      </button>
                    </form>
                  </dialog>
                  <button
                    v-if="approved"
                    class="text-link"
                    type="button"
                    data-action="demo-reset"
                    @click="resetDemo"
                  >
                    Reiniciar demo
                  </button>
                  <div class="demo-status" role="status" aria-live="polite">{{ demoStatus }}</div>
                </div>
              </article>
              <article class="step" id="paso-5">
                <div class="reveal">
                  <span class="step-num">05</span>
                  <h3 v-if="isCopyV2">Organizás el proyecto</h3>
                  <h3 v-else>Gestión de proyecto.</h3>
                  <p v-if="isCopyV2">
                    Agenda, pagos y checklist en un solo lugar. Registrá señas, pagos y saldos, y
                    tu cliente ve lo que vos elijas, sin tener que preguntarte.
                  </p>
                  <p v-else>
                    Agenda, pagos y checklist en un solo lugar. Tu cliente entra con su PIN y ve
                    cómo va todo. Sin “¿cómo vamos?” por WhatsApp.
                  </p>
                  <router-link
                    class="deep-link"
                    :to="copyLink('/proyectos')"
                    data-action="home-deep-dive"
                    data-context="proyectos"
                    >Del sí al proyecto armado <span aria-hidden="true">→</span></router-link
                  >
                </div>
                <div class="mock reveal">
                  <div class="mock-top">
                    <span>El cumple de Juli</span>
                    <span class="status">En marcha</span>
                  </div>
                  <div class="mock-title">Sin perder el hilo.</div>
                  <div class="row">
                    <span>✓ Presupuesto aprobado</span>
                    <b>Listo</b>
                  </div>
                  <div class="row">
                    <span>✓ Seña recibida</span>
                    <b>50%</b>
                  </div>
                  <div class="row">
                    <span>Evento en agenda</span>
                    <b>24 OCT</b>
                  </div>
                  <div class="row">
                    <span>Confirmar menú</span>
                    <b>Pendiente</b>
                  </div>
                  <div class="mock-foot">Acceso del cliente con PIN · Todo al día.</div>
                </div>
              </article>
            </div>
          </div>
        </div>
      </section>
      <section class="section compare wrap" id="control" aria-labelledby="compare-title">
        <div class="eyebrow">Inteligencia que acompaña</div>
        <div class="compare-heading reveal">
          <h2 id="compare-title">
            Automatizá sin sonar a robot. <span class="accent">Y seguí en control.</span>
          </h2>
          <div class="control-seal" aria-hidden="true">Tu criterio.<br />Siempre.</div>
        </div>
        <div class="compare-grid">
          <div class="compare-col reveal">
            <h3>LO QUE HACE</h3>
            <ul v-if="isCopyV2">
              <li>Lee la consulta que llega por tu link.</li>
              <li>Prepara una base con tu catálogo e historial.</li>
              <li>Te muestra la actividad del presupuesto.</li>
              <li>Vos revisás cada presupuesto y decidís cuándo compartirlo.</li>
            </ul>
            <ul v-else>
              <li>Lee la consulta.</li>
              <li>Prepara una base con tu catálogo e historial.</li>
              <li>Te muestra la actividad del presupuesto.</li>
              <li>Te ayuda a presupuestar, con tu revisión.</li>
            </ul>
          </div>
          <div class="compare-col reveal">
            <h3>LO QUE NO HACE</h3>
            <ul v-if="isCopyV2">
              <li>No comparte presupuestos sin tu revisión.</li>
              <li>No decide precios ni condiciones por vos.</li>
              <li>No es un chatbot.</li>
              <li>No reemplaza tu criterio.</li>
            </ul>
            <ul v-else>
              <li>No responde por vos.</li>
              <li>No manda sin aprobación.</li>
              <li>No es un chatbot.</li>
              <li>No reemplaza tu criterio.</li>
            </ul>
          </div>
        </div>
      </section>
      <section class="section docs wrap" id="documentos" aria-labelledby="docs-title">
        <div class="docs-grid">
          <div class="docs-copy reveal">
            <div class="eyebrow">Lo que hacés vale. Que se note.</div>
            <h2 v-if="isCopyV2" id="docs-title">
              Antes, durante y después del trabajo:
              <span class="accent">documentos con tu marca.</span>
            </h2>
            <h2 v-else id="docs-title">
              Ganaste el trabajo. Ahora vienen los papeles.
              <span class="accent">También se arman solos.</span>
            </h2>
            <p v-if="isCopyV2">
              Prio genera documentos profesionales con tu marca: propuestas, contratos, guías e
              informes. El presupuesto ordena servicios e importes; la propuesta desarrolla
              alcance y método. Respondés unas pocas preguntas, elegís entre 4 estilos y revisás
              el diseño antes de descargar el PDF.
            </p>
            <p v-else>
              Prio genera documentos profesionales. Respondés unas pocas preguntas, elegís entre 4
              estilos y editás lo que necesites. Una vista WYSIWYG: lo que ves es lo que sale en el
              PDF.
            </p>
            <div class="doc-types">
              <span>Propuestas</span>
              <span>Contratos</span>
              <span>Guías</span>
              <span>Informes</span>
            </div>
            <router-link
              class="deep-link"
              :to="copyLink('/documentos')"
              data-action="home-deep-dive"
              data-context="documentos"
              >Documentos profesionales con tu marca <span aria-hidden="true">→</span></router-link
            >
          </div>
          <div class="reveal">
            <div class="workbench">
              <div id="doc" class="doc" :data-skin="activeSkin">
                <header>
                  <strong>casa olivia</strong>
                  <span>PROPUESTA / 024</span>
                </header>
                <h3>Los detalles<br />hacen la fiesta.</h3>
                <p>
                  Juli, esta es nuestra propuesta para tu cumpleaños. Un menú para compartir, una
                  mesa para encontrarse y todo listo para disfrutar.
                </p>
                <div class="doc-rule"></div>
                <div class="doc-rule"></div>
                <div class="doc-rule short"></div>
                <footer>
                  <span>HECHO PARA VOS</span>
                  <span>01 / 02</span>
                </footer>
              </div>
              <div class="skin-picker" role="group" aria-label="Estilo del documento">
                <button
                  v-for="skin in skins"
                  :key="skin.id"
                  type="button"
                  data-action="doc-skin"
                  :data-context="skin.id"
                  :aria-pressed="activeSkin === skin.id"
                  aria-controls="doc"
                  @click="selectSkin(skin.id)"
                >
                  {{ skinLabel[skin.id] }}
                </button>
              </div>
            </div>
            <p class="doc-caption mono">4 ESTILOS. TU MARCA EN TODOS. ↑</p>
          </div>
        </div>
      </section>
      <section class="trust wrap" aria-labelledby="trust-title">
        <div class="trust-box">
          <div class="reveal">
            <div class="eyebrow">Con los pies en tu negocio</div>
            <h2 id="trust-title">No es magia.<br />Es tu catálogo.</h2>
            <p>
              Tu catálogo y tus presupuestos anteriores son la referencia. Prio te ayuda a armar una
              base; vos revisás los servicios, precios y condiciones antes de compartir.
            </p>
            <router-link
              class="deep-link"
              :to="copyLink('/catalogo')"
              data-action="home-deep-dive"
              data-context="catalogo"
              >Tu lista de precios, viva <span aria-hidden="true">→</span></router-link
            >
          </div>
          <div class="trust-catalog reveal">
            <div class="mono">MIS SERVICIOS / CASA OLIVIA</div>
            <div class="row">
              <span>Catering de cumpleaños</span>
              <b>$ 480.000</b>
            </div>
            <div class="row">
              <span>Mesa dulce</span>
              <b>$ 85.000</b>
            </div>
            <div class="row">
              <span>Vajilla</span>
              <b>$ 45.000</b>
            </div>
            <div class="demo-note">Catálogo ilustrativo · Lo definís vos. Lo usa Prio.</div>
          </div>
        </div>
      </section>
      <section v-if="isCopyV2" class="section wrap faq" aria-labelledby="faq-title">
        <div class="eyebrow">Antes de empezar</div>
        <h2 id="faq-title">Lo que necesitás saber <span class="accent">para probar.</span></h2>
        <div class="faq-grid" data-context="copy-faq">
          <article class="faq-item">
            <h3>¿Mi cliente necesita una cuenta?</h3>
            <p>
              No. Recibe tu link, elige opcionales y aprueba. Para seguir su proyecto entra con
              un PIN, sin instalar nada.
            </p>
          </article>
          <article class="faq-item">
            <h3>¿Y si mis precios cambian según el trabajo?</h3>
            <p>
              Marcás el servicio como variable y definís el monto en cada presupuesto. El resto
              de la lista sigue igual.
            </p>
          </article>
          <article class="faq-item">
            <h3>¿Cómo empiezo?</h3>
            <p>
              Podés armar tu primer presupuesto a mano o cargar la lista que ya usás. Después,
              guardá una plantilla para aprovecharla en los siguientes.
            </p>
          </article>
          <article class="faq-item">
            <h3>¿La prueba tiene costo?</h3>
            <p>La prueba es de 30 días y no pide tarjeta.</p>
          </article>
        </div>
      </section>
      <section
        class="closing"
        data-context="home-closing"
        :data-motion="closingVisible && !closingPaused && !reducedMotion"
        aria-labelledby="closing-title"
      >
        <span
          ref="flowerRef"
          class="closing-flower"
          data-context="closing-flower"
          aria-hidden="true"
          >✳</span
        >
        <div class="closing-ring" data-context="closing-ring" aria-hidden="true"></div>
        <div class="wrap reveal">
          <div class="eyebrow">Un poco de orden. Mucho por hacer.</div>
          <h2 v-if="isCopyV2" id="closing-title">
            Menos tiempo armando presupuestos.
            <span>Más tiempo para tu trabajo.</span>
          </h2>
          <h2 v-else id="closing-title">
            Tu trabajo no tiene por qué pesarte. <span>Volvé a enamorarte de tu negocio.</span>
          </h2>
          <p v-if="isCopyV2">Consultas, presupuestos y proyectos en una sola app.</p>
          <p v-else>Prio se ocupa del sistema — vos volvés a hacer lo que amás.</p>
          <a class="cta" :href="SIGNUP_URL">Probá gratis <span aria-hidden="true">↗</span> </a>
          <div class="guarantee">Sin tarjeta · Cancelás cuando quieras</div>
          <button
            v-if="!reducedMotion"
            class="motion-toggle"
            type="button"
            data-action="closing-motion"
            :aria-pressed="closingPaused"
            @click="closingPaused = !closingPaused"
          >
            {{ closingPaused ? 'Reanudar animación' : 'Pausar animación' }}
          </button>
        </div>
      </section>
    </main>
  </div>
</template>

<script setup lang="ts">
import { computed, onMounted, onUnmounted, ref } from 'vue';
import { useHead } from '@unhead/vue';
import { useScrollReveal } from '@/composables/useScrollReveal';
import { useCopyVariant } from '@/composables/useCopyVariant';
import { SIGNUP_URL } from '@/constants';

const { isCopyV2, copyLink } = useCopyVariant();

useHead({
  title: 'prio. — Menos vueltas. Más hacer.',
  meta: [
    {
      name: 'description',
      content:
        'No emprendiste para vivir haciendo presupuestos. Prio ordena tu negocio del primer hola al último pago, sin el caos.',
    },
    { name: 'theme-color', content: '#f7f3fb' },
  ],
  link: [
    { rel: 'preconnect', href: 'https://fonts.googleapis.com' },
    { rel: 'preconnect', href: 'https://fonts.gstatic.com', crossorigin: '' },
    {
      rel: 'stylesheet',
      href: 'https://fonts.googleapis.com/css2?family=Urbanist:wght@500;600;700;800;900&family=Inter:wght@400;500;600;700&family=IBM+Plex+Mono:wght@400;500&display=swap',
    },
  ],
});

// Hero chaos/order scene (illustrative demo, typed Vue state).
const mode = ref<'chaos' | 'order'>('order');

function setMode(next: 'chaos' | 'order'): void {
  mode.value = next;
}

// Trades marquee pause control.
const marqueePaused = ref(false);

function toggleMarquee(): void {
  marqueePaused.value = !marqueePaused.value;
}

// Step 4: live total + simulated approval (no API, nothing is sent).
interface DemoOptional {
  id: string;
  name: string;
  price: number;
  on: boolean;
}

const BASE_TOTAL = 480000;
const optionals = ref<DemoOptional[]>([
  { id: 'mesa-dulce', name: 'Mesa dulce', price: 85000, on: false },
  { id: 'vajilla', name: 'Vajilla', price: 45000, on: false },
]);
const approved = ref(false);
const demoStatus = ref('Demo ilustrativa. No se envía ni se guarda nada.');
const approveRef = ref<HTMLButtonElement | null>(null);
const approvalDialogRef = ref<HTMLDialogElement | null>(null);

const moneyFormat = new Intl.NumberFormat('es-AR');

function formatMoney(value: number): string {
  return '$ ' + moneyFormat.format(value);
}

const total = computed<number>(
  () => BASE_TOTAL + optionals.value.reduce((sum, opt) => sum + (opt.on ? opt.price : 0), 0),
);
const formattedTotal = computed<string>(() => formatMoney(total.value));

function resetDemo(): void {
  optionals.value.forEach((opt) => {
    opt.on = false;
  });
  approved.value = false;
  demoStatus.value = 'Demo ilustrativa. No se envía ni se guarda nada.';
}

function approveDemo(): void {
  approvalDialogRef.value?.close();
  approved.value = true;
  demoStatus.value =
    'Aprobación simulada por ' +
    formattedTotal.value +
    '. Podés reiniciar la demo para volver a probar.';
  if (!reducedMotion.value && approveRef.value && typeof approveRef.value.animate === 'function') {
    approveRef.value.animate(
      [{ transform: 'scale(.98)' }, { transform: 'scale(1.025)' }, { transform: 'scale(1)' }],
      { duration: 380, easing: 'ease-out' },
    );
  }
}

// Document skins (4 styles, local demo).
interface DocSkin {
  id: string;
  label: string;
}

const skins: DocSkin[] = [
  { id: 'simple', label: 'Simple' },
  { id: 'editorial', label: 'Editorial' },
  { id: 'expressive', label: 'Expresivo' },
  { id: 'formal', label: 'Formal' },
];

// V2 display labels match the Documentos style names; ids (and CSS skins)
// stay untouched so the demo keeps working.
const skinLabel = computed<Record<string, string>>(() =>
  isCopyV2.value
    ? { simple: 'Minimal', editorial: 'Editorial', expressive: 'Moderno', formal: 'Clásico' }
    : { simple: 'Simple', editorial: 'Editorial', expressive: 'Expresivo', formal: 'Formal' },
);
const activeSkin = ref<string>('simple');

function selectSkin(id: string): void {
  activeSkin.value = id;
}

// Scroll-driven story nav + progress + counters (client-only, cleaned up).
const rootRef = ref<HTMLElement | null>(null);
const counterRef = ref<HTMLElement | null>(null);
const sparkRef = ref<HTMLElement | null>(null);
const flowerRef = ref<HTMLElement | null>(null);
const closingVisible = ref(false);
const closingPaused = ref(false);
const activeStep = ref(0);
const scrollProgress = ref(0);
const reducedMotion = ref(false);
let disposed = false;
let queued = false;
let rafId = 0;
let counterRafId = 0;
let counterDone = false;
let mediaQuery: MediaQueryList | null = null;

function animateCounter(el: HTMLElement): void {
  const start = performance.now();
  const tick = (now: number): void => {
    if (disposed) return;
    const progress = Math.min(1, (now - start) / 1000);
    el.textContent = String(Math.round(1 + 39 * (1 - Math.pow(1 - progress, 3))));
    if (progress >= 1 || reducedMotion.value) {
      el.textContent = '40';
      return;
    }
    counterRafId = requestAnimationFrame(tick);
  };
  counterRafId = requestAnimationFrame(tick);
}

function updateScroll(): void {
  queued = false;
  if (disposed) return;
  const root = rootRef.value;
  if (!root || typeof window === 'undefined') return;
  const height = window.innerHeight;
  const steps = Array.from(root.querySelectorAll('.step'));
  let active = 0;
  steps.forEach((step, index) => {
    if (step.getBoundingClientRect().top < height * 0.45) active = index;
  });
  activeStep.value = active;
  const length = document.documentElement.scrollHeight - height;
  scrollProgress.value = length > 0 ? Math.max(0, Math.min(1, window.scrollY / length)) : 0;
  if (!reducedMotion.value) {
    const scene = root.querySelector('.scene');
    const heroRect = scene?.getBoundingClientRect();
    if (heroRect && heroRect.bottom > 0 && heroRect.top < height && sparkRef.value) {
      sparkRef.value.style.transform = 'rotate(' + (10 + window.scrollY * 0.07) + 'deg)';
    }
    const closing = root.querySelector('.closing');
    const closingRect = closing?.getBoundingClientRect();
    closingVisible.value = !!closingRect && closingRect.top < height && closingRect.bottom > 0;
    if (closingVisible.value && closingRect && !closingPaused.value && flowerRef.value) {
      flowerRef.value.style.transform = 'rotate(' + (height - closingRect.top) * 0.035 + 'deg)';
    }
  } else {
    if (sparkRef.value) sparkRef.value.style.transform = '';
    if (flowerRef.value) flowerRef.value.style.transform = '';
  }
  const counter = counterRef.value;
  if (counter && !counterDone) {
    const rect = counter.getBoundingClientRect();
    if (rect.top < height && rect.bottom > 0) {
      counterDone = true;
      if (!reducedMotion.value) animateCounter(counter);
    }
  }
}

function queueScroll(): void {
  if (!queued && !disposed) {
    queued = true;
    rafId = requestAnimationFrame(updateScroll);
  }
}

function onMotionChange(): void {
  reducedMotion.value = mediaQuery?.matches ?? false;
  queueScroll();
}

onMounted(() => {
  mediaQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
  reducedMotion.value = mediaQuery.matches;
  mediaQuery.addEventListener('change', onMotionChange);
  window.addEventListener('scroll', queueScroll, { passive: true });
  window.addEventListener('resize', queueScroll);
  if (document.fonts) {
    document.fonts.ready
      .then(() => {
        if (!disposed) queueScroll();
      })
      .catch(() => undefined);
  }
  queueScroll();
});

onUnmounted(() => {
  disposed = true;
  window.removeEventListener('scroll', queueScroll);
  window.removeEventListener('resize', queueScroll);
  mediaQuery?.removeEventListener('change', onMotionChange);
  cancelAnimationFrame(rafId);
  cancelAnimationFrame(counterRafId);
});

useScrollReveal();
</script>

<style scoped>
h1,
h2,
h3 {
  font-family: Urbanist, Arial, sans-serif;
  font-weight: 800;
  letter-spacing: -0.045em;
  line-height: 1.02;
}
h1 {
  font-size: clamp(52px, 6.5vw, 88px);
}
h2 {
  font-size: clamp(39px, 4.8vw, 65px);
}
h3 {
  font-size: 31px;
}

a {
  color: inherit;
  text-decoration: none;
}
button,
input {
  font: inherit;
  color: inherit;
}
button {
  cursor: pointer;
  border: 0;
}
button,
a,
input {
  -webkit-tap-highlight-color: transparent;
}
a:focus-visible,
button:focus-visible,
input:focus-visible {
  outline: 3px solid var(--violet);
  outline-offset: 5px;
}
button,
a {
  touch-action: manipulation;
}
.wrap {
  width: min(1180px, calc(100% - 64px));
  margin: auto;
}
.mono,
.eyebrow {
  font-family: 'IBM Plex Mono', monospace;
  font-size: 10px;
  letter-spacing: 0.08em;
}
.eyebrow {
  text-transform: uppercase;
  color: var(--violet);
  margin-bottom: 25px;
  display: flex;
  align-items: center;
  gap: 10px;
}
.eyebrow:before {
  content: '';
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: var(--pink);
}
.cta {
  position: relative;
  overflow: hidden;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 33px;
  min-height: 55px;
  padding: 15px 25px;
  border-radius: 17px;
  background: var(--aurora);
  font-weight: 700;
  font-size: 13px;
  border: 1px solid #c9aee0;
  isolation: isolate;
  transition: transform 0.25s var(--ease);
}
.cta:before {
  content: '';
  position: absolute;
  inset: -80% -60%;
  background: linear-gradient(100deg, transparent 42%, #ffffff85 50%, transparent 58%);
  transform: translateX(-65%) rotate(-10deg);
  z-index: -1;
}
.cta:hover:before,
.cta:focus-visible:before {
  animation: sheen 0.8s var(--ease);
}
.cta:active {
  transform: scale(0.97);
}
.cta span {
  font-size: 24px;
  line-height: 1;
}
.guarantee {
  font-size: 10px;
  color: var(--muted);
  margin-top: 14px;
}
.hero {
  display: grid;
  grid-template-columns: 1.13fr 1fr;
  gap: 50px;
  padding: 55px 0 65px;
  align-items: center;
}
.hero h1 {
  max-width: 660px;
}

.hero .accent {
  position: relative;
  display: inline-block;
}
.hero .accent:after {
  content: '';
  position: absolute;
  left: 0;
  right: 0;
  bottom: -8px;
  height: 11px;
  border-top: 3px solid var(--pink);
  border-radius: 50%;
  transform: rotate(-3deg);
}
.hero-copy > p {
  font-size: 14px;
  max-width: 510px;
  margin: 29px 0 25px;
  line-height: 1.85;
}
.hero-art {
  min-width: 0;
  position: relative;
  padding: 30px 0 15px;
}
.scene {
  position: relative;
  height: 410px;
  isolation: isolate;
}
.scene:before {
  content: '';
  position: absolute;
  inset: 15px 0 20px;
  border-radius: 45% 55% 35% 60%;
  background: var(--aurora);
  opacity: 0.7;
  transform: rotate(-9deg);
  z-index: -2;
}
.orbit {
  position: absolute;
  inset: 30px -10px 0;
  border: 1px solid #b6a0ce;
  border-radius: 50%;
  transform: rotate(-28deg);
  z-index: -1;
}
.orbit:after {
  content: '';
  position: absolute;
  inset: 30px -8px;
  border: 1px solid #b6a0ce;
  border-radius: 50%;
  transform: rotate(52deg);
}
.spark {
  position: absolute;
  right: 5px;
  top: 0;
  font-size: 70px;
  color: var(--violet);
  line-height: 1;
  transform: rotate(10deg);
}
.hero-note {
  position: absolute;
  left: 2px;
  top: 7px;
  font-family: Urbanist;
  font-size: 16px;
  line-height: 1.1;
  transform: rotate(-9deg);
  font-weight: 700;
  z-index: 3;
  color: #593f73;
}
.hero-note span {
  display: block;
  font-size: 27px;
  padding-top: 7px;
}
.proposal-stack {
  position: absolute;
  inset: 46px 10% 42px;
  transition:
    transform 0.5s var(--ease),
    opacity 0.3s;
  transform: rotate(-4deg);
}
.proposal-stack:before {
  content: '';
  position: absolute;
  inset: 5px -3px -6px 5px;
  border: 1px solid white;
  background: var(--aurora);
  border-radius: 23px;
  transform: rotate(6deg);
  z-index: -1;
}
.proposal {
  height: 100%;
  border: 1px solid #fff;
  background: #fffcff;
  border-radius: 23px;
  padding: 23px;
  box-shadow: 0 18px 45px #57397c12;
}
.proposal-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  padding-bottom: 16px;
  border-bottom: 1px solid var(--line);
}
.studio {
  font-family: Urbanist;
  font-weight: 800;
  font-size: 22px;
  letter-spacing: -1px;
}
.mini-tag {
  font-size: 8px;
  border: 1px solid #dfd3e8;
  border-radius: 20px;
  padding: 4px 8px;
  color: #80698f;
}
.proposal h3 {
  font-size: 29px;
  margin: 21px 0 8px;
}
.proposal p {
  font-size: 9px;
}
.row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  border-bottom: 1px solid #e9e1ef;
  padding: 12px 0;
  font-size: 11px;
}
.row b {
  font-weight: 600;
  white-space: nowrap;
}
.total {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding-top: 15px;
  font-size: 10px;
}
.total strong {
  font-family: Urbanist;
  font-size: 29px;
  letter-spacing: -1px;
}
.accepted {
  position: absolute;
  right: -3px;
  bottom: 18px;
  background: var(--lime);
  color: #35442a;
  padding: 14px 20px;
  border-radius: 18px;
  transform: rotate(5deg);
  font-size: 12px;
  font-weight: 600;
  transition:
    transform 0.45s var(--ease),
    opacity 0.3s;
}
.accepted small {
  display: block;
  font-size: 9px;
  font-weight: 400;
  margin-left: 22px;
}
.accepted b {
  margin-right: 10px;
}
.scene-controls {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 13px;
  margin-top: 16px;
}
.segmented {
  display: flex;
  gap: 3px;
  background: #eee6f6;
  border: 1px solid #ded0e9;
  border-radius: 30px;
  padding: 4px;
}
.segmented button {
  min-height: 39px;
  padding: 7px 18px;
  border-radius: 25px;
  background: transparent;
  font-size: 11px;
}
.segmented button[aria-pressed='true'] {
  background: white;
  color: var(--violet);
}
.scene-controls > span {
  font-size: 9px;
  color: var(--muted);
}
.chat {
  position: absolute;
  background: #fffcff;
  border: 1px solid #e1d4e9;
  border-radius: 18px;
  padding: 18px;
  width: 75%;
  font-size: 11px;
  left: 4%;
  top: 55px;
  transform: rotate(-7deg) translateY(20px);
  opacity: 0;
  visibility: hidden;
  transition:
    transform 0.5s var(--ease),
    opacity 0.3s;
}
.chat small {
  display: block;
  font-size: 9px;
  color: #95839f;
  margin-top: 9px;
}
.chat:nth-child(2) {
  left: 22%;
  top: 165px;
  width: 72%;
  transform: rotate(8deg);
}
.chat:nth-child(3) {
  left: 8%;
  top: 270px;
  width: 76%;
  transform: rotate(-3deg);
}
.scene[data-mode='chaos'] .proposal-stack {
  opacity: 0;
  visibility: hidden;
  transform: rotate(4deg) translateY(25px);
}
.scene[data-mode='chaos'] .accepted {
  opacity: 0;
  visibility: hidden;
  transform: translateY(15px);
}
.scene[data-mode='chaos'] .chat {
  opacity: 1;
  visibility: visible;
  transform: rotate(-5deg);
}
.scene[data-mode='chaos'] .chat:nth-child(2) {
  transform: rotate(5deg);
}
.ribbon-shell {
  overflow: hidden;
  padding: 10px 0;
}
.ribbon {
  background: var(--aurora);
  transform: rotate(-1.2deg);
  padding: 16px 0;
  position: relative;
}
.marquee {
  display: flex;
  width: max-content;
  animation: marquee 35s linear infinite;
}
.trade-set {
  display: flex;
  gap: 33px;
  align-items: center;
  padding-right: 33px;
  font-family: Urbanist;
  font-size: 23px;
  font-weight: 700;
}
.trade-set i {
  font-style: normal;
  font-size: 22px;
  color: #6d4789;
}
.ribbon:hover .marquee,
.ribbon:focus-within .marquee,
.ribbon.paused .marquee {
  animation-play-state: paused;
}
.pause {
  position: absolute;
  right: 15px;
  top: 13px;
  width: 37px;
  height: 37px;
  background: #f4e9fc;
  border-radius: 50%;
  font-size: 12px;
  border: 1px solid #c7abd9;
}
.section {
  padding: 100px 0;
}
.pain-heading {
  display: grid;
  grid-template-columns: 1.3fr 0.7fr;
  gap: 85px;
  align-items: center;
}
.pain-heading h2 {
  max-width: 760px;
  font-size: 53px;
}
.counter-block {
  display: flex;
  align-items: center;
  gap: 25px;
}
.counter {
  font-family: Urbanist;
  font-size: 132px;
  font-weight: 800;
  letter-spacing: -0.09em;
  line-height: 1;
  color: var(--violet);
}
.counter-block p {
  font-size: 12px;
  max-width: 125px;
}
.pain-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;
  margin: 42px 0 30px;
}
.pain-card {
  background: #eee6f7;
  border: 1px solid #e0d2ed;
  padding: 27px;
  border-radius: 25px;
  position: relative;
}
.pain-card:nth-child(2) {
  background: #fff7ee;
  border-color: #f1dfcd;
  border-radius: 25px 25px 7px 25px;
}
.pain-card:nth-child(3) {
  background: #fae9ee;
  border-color: #efd6df;
}
.pain-card .mono {
  font-size: 9px;
  color: #8b6f9d;
}
.pain-card h3 {
  font-size: 32px;
  margin: 28px 0 17px;
}
.pain-card p {
  font-size: 12px;
}
.pain-end {
  text-align: center;
  color: var(--ink);
  font-family: Urbanist;
  font-size: 23px;
  font-weight: 600;
}
.flow-section {
  background: #ece4f6;
  border-radius: 55px 55px 0 0;
  padding-bottom: 75px;
}
.flow-heading {
  display: flex;
  align-items: end;
  justify-content: space-between;
  gap: 40px;
  margin-bottom: 45px;
}
.flow-heading h2 {
  max-width: 630px;
}
.flow-heading p {
  max-width: 265px;
  font-size: 14px;
}
.flow-heading h2 span {
  display: inline-block;
  background: var(--lime);
  padding: 0 9px 6px;
  border-radius: 8px;
  transform: rotate(-2deg);
}
.story {
  display: grid;
  grid-template-columns: 170px 1fr;
  gap: 55px;
  align-items: start;
}
.story-nav {
  position: sticky;
  top: calc(var(--nav-h) + 16px);
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding-top: 20px;
}
.story-nav a {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 10px;
  color: #8a759d;
  font-size: 11px;
  border-radius: 12px;
  transition:
    background 0.25s,
    color 0.25s;
}
.story-nav a span {
  font-family: 'IBM Plex Mono';
  font-size: 10px;
}
.story-nav a.active {
  background: #fffaff;
  color: var(--violet);
  font-weight: 600;
}
.step {
  display: grid;
  grid-template-columns: 1fr 1.05fr;
  gap: 36px;
  align-items: center;
  padding: 50px 0 60px;
  border-bottom: 1px solid #d8c9e5;
  min-height: 415px;
  scroll-margin-top: 30px;
}
.step:first-child {
  padding-top: 15px;
}
.step:last-child {
  border-bottom: 0;
  padding-bottom: 0;
}
.step-num {
  font-family: 'IBM Plex Mono';
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 45px;
  height: 33px;
  border: 1px solid #bda5d2;
  border-radius: 30px;
  font-size: 11px;
  color: var(--violet);
  margin-bottom: 22px;
}
.step h3 {
  font-size: 36px;
}
.step p {
  font-size: 12px;
  margin-top: 20px;
  line-height: 1.85;
}
.mock {
  position: relative;
  background:
    linear-gradient(140deg, #fffaff, #fbf4f7) padding-box,
    var(--brand) border-box;
  border: 1px solid transparent;
  border-radius: 25px;
  padding: 25px;
  min-width: 0;
}
.mock-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  padding-bottom: 15px;
  border-bottom: 1px solid var(--line);
  font-size: 10px;
}
.status {
  background: #e5f5de;
  color: #3b6137;
  border-radius: 20px;
  padding: 4px 8px;
  font-size: 8px;
  white-space: nowrap;
}
.status.draft {
  background: #fff0d3;
  color: #815010;
}
.mock-title {
  font-family: Urbanist;
  font-size: 27px;
  line-height: 1.08;
  font-weight: 800;
  letter-spacing: -0.03em;
  margin: 20px 0 15px;
}
.field {
  background: white;
  border: 1px solid #e4d9eb;
  border-radius: 12px;
  padding: 10px 12px;
  font-size: 10px;
  margin: 9px 0;
}
.field small {
  display: block;
  font-size: 8px;
  color: #8e7a9a;
}
.mock-foot {
  background: #eee6f6;
  border-radius: 10px;
  color: var(--violet);
  padding: 10px 12px;
  margin-top: 16px;
  font-size: 9px;
}
.catalog-line {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 0;
  font-size: 10px;
  border-bottom: 1px solid #e7dcec;
}
.check {
  display: grid;
  place-items: center;
  background: #e5f5de;
  color: #3b6137;
  border-radius: 7px;
  width: 23px;
  height: 23px;
  flex-shrink: 0;
}
.phone-preview {
  margin: 17px auto 0;
  padding: 20px;
  border: 1px solid #d7c7e3;
  border-radius: 23px;
  max-width: 235px;
  background: #fffcff;
}
.phone-preview h4 {
  font-family: Urbanist;
  font-size: 27px;
  letter-spacing: -1px;
  line-height: 1.05;
  margin: 0 0 15px;
  color: var(--violet);
}
.phone-preview .row {
  font-size: 9px;
}
.demo-note {
  font-size: 9px;
  color: #8a7996;
  margin-top: 12px;
}
.optional {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 0;
  border-bottom: 1px solid var(--line);
  font-size: 10px;
  cursor: pointer;
}
.optional span {
  flex: 1;
}
.optional input {
  width: 18px;
  height: 18px;
  accent-color: var(--violet);
  cursor: pointer;
}
.optional b {
  font-weight: 500;
}
.approve {
  width: 100%;
  margin-top: 17px;
  background: var(--aurora);
  min-height: 43px;
  border-radius: 12px;
  font-size: 11px;
  font-weight: 600;
  transition: transform 0.25s var(--ease);
}
.approve:active {
  transform: scale(0.98);
}
.approve:disabled {
  cursor: default;
  background: #e5f5de;
  color: #355d34;
}
.demo-status {
  font-size: 9px;
  line-height: 1.6;
  margin-top: 10px;
  min-height: 29px;
  color: #7c688c;
}
.compare {
  padding-top: 90px;
}
.compare-heading {
  display: flex;
  justify-content: space-between;
  align-items: end;
  gap: 50px;
}
.compare-heading h2 {
  max-width: 800px;
}
.control-seal {
  width: 100px;
  height: 100px;
  border-radius: 50%;
  border: 1px solid #bfabcf;
  background: #eae0f6;
  display: grid;
  place-content: center;
  text-align: center;
  font-family: Urbanist;
  font-size: 17px;
  line-height: 1.1;
  font-weight: 700;
  flex-shrink: 0;
  transform: rotate(9deg);
}
.compare-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 22px;
  margin-top: 40px;
}
.compare-col {
  border: 1px solid #ded4e8;
  border-radius: 27px;
  background: #fffaff;
  padding: 30px;
}
.compare-col:first-child {
  background: #eef5e6;
  border-color: #dae7ca;
}
.compare-col h3 {
  font-family: 'IBM Plex Mono';
  font-size: 11px;
  letter-spacing: 0.06em;
  margin-bottom: 19px;
}
.compare-col ul {
  list-style: none;
  margin: 0;
  padding: 0;
}
.compare-col li {
  display: flex;
  gap: 14px;
  align-items: center;
  padding: 12px 0;
  border-bottom: 1px solid #dce3d2;
  font-size: 12px;
}
.compare-col li:last-child {
  border-bottom: 0;
}
.compare-col li:before {
  content: '✓';
  color: #507342;
}
.compare-col:last-child li {
  border-color: #e8deef;
}
.compare-col:last-child li:before {
  content: '×';
  color: #a17a91;
  font-size: 17px;
}
.docs {
  padding-top: 15px;
}
.docs-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 85px;
  align-items: center;
}
.docs-copy h2 {
  font-size: 54px;
}
.docs-copy p {
  font-size: 13px;
  margin-top: 24px;
  max-width: 460px;
}
.doc-types {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
  margin-top: 23px;
}
.doc-types span {
  font-size: 10px;
  border: 1px solid #d6c4e2;
  border-radius: 22px;
  padding: 6px 10px;
}
.workbench {
  background: var(--aurora);
  border-radius: 35px 35px 80px 35px;
  padding: 32px;
  position: relative;
}
.doc {
  position: relative;
  background: #fffcff;
  border: 1px solid white;
  padding: 28px;
  border-radius: 8px;
  min-height: 360px;
  transform: rotate(-3deg);
  color: #5e4279;
  transition:
    background 0.25s,
    color 0.25s,
    transform 0.35s var(--ease);
}
.doc header {
  display: flex;
  justify-content: space-between;
  font-size: 9px;
  border-bottom: 1px solid currentColor;
  padding-bottom: 18px;
}
.doc h3 {
  font-size: 36px;
  margin: 27px 0 18px;
}
.doc p {
  font-size: 10px;
  color: inherit;
}
.doc-rule {
  height: 2px;
  background: currentColor;
  opacity: 0.15;
  margin-top: 16px;
}
.doc-rule.short {
  width: 65%;
}
.doc footer {
  display: flex;
  justify-content: space-between;
  margin-top: 24px;
  font-size: 8px;
}
.doc[data-skin='editorial'] {
  background: #fff4e6;
  color: #725242;
  transform: rotate(1deg);
}
.doc[data-skin='editorial'] h3 {
  font-family: Georgia, serif;
  font-size: 33px;
  font-style: italic;
  font-weight: 400;
}
.doc[data-skin='expressive'] {
  background: #ebe0ff;
  color: #563399;
  transform: rotate(-1deg);
}
.doc[data-skin='expressive'] h3 {
  font-size: 42px;
}
.doc[data-skin='expressive'] header {
  border-bottom: 6px solid #b38cdb;
}
.doc[data-skin='formal'] {
  background: #fff;
  color: #40586b;
  border-top: 9px solid #92a9b2;
  transform: rotate(0);
}
.doc[data-skin='formal'] h3 {
  font-family: Georgia, serif;
  font-size: 29px;
  letter-spacing: -1px;
}
.skin-picker {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: 4px;
  margin-top: 27px;
}
.skin-picker button {
  background: #ffffff50;
  border: 1px solid transparent;
  padding: 9px 10px;
  border-radius: 25px;
  font-size: 9px;
  min-height: 38px;
}
.skin-picker button[aria-pressed='true'] {
  background: white;
  border-color: #c4acd6;
  color: var(--violet);
}
.doc-caption {
  text-align: center;
  font-size: 9px;
  margin-top: 15px;
}
.trust {
  padding: 0 0 90px;
}
.trust-box {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 80px;
  align-items: center;
  background: #eee7f7;
  border-radius: 30px;
  padding: 45px;
}
.trust h2 {
  font-size: 45px;
}
.trust p {
  font-size: 12px;
  margin-top: 20px;
  max-width: 440px;
}
.trust-catalog {
  background: #fffcff;
  border-radius: 20px;
  padding: 23px;
  border: 1px solid #ded1e9;
}
.trust-catalog .mono {
  color: var(--violet);
  margin-bottom: 12px;
}
.closing {
  text-align: center;
  background: var(--aurora);
  border-radius: 65px 65px 0 0;
  padding: 90px 0;
  position: relative;
  overflow: hidden;
  isolation: isolate;
}
.closing .eyebrow {
  justify-content: center;
  color: #684781;
}
.closing h2 {
  font-size: clamp(45px, 6.2vw, 85px);
  max-width: 960px;
  margin: auto;
}
.closing h2 span {
  color: #62408f;
}
.closing p {
  font-size: 14px;
  max-width: 470px;
  margin: 26px auto;
}
.closing .cta {
  background: #fffcff;
  border-color: #fff;
}
.closing .guarantee {
  color: #70557d;
}
.closing-flower {
  position: absolute;
  left: -35px;
  top: 60px;
  font-size: 180px;
  color: #ffffff65;
  line-height: 1;
  z-index: -1;
  pointer-events: none;
  animation: closing-sway 14s ease-in-out infinite alternate paused;
}
.closing-ring {
  position: absolute;
  right: -130px;
  bottom: -100px;
  width: 370px;
  height: 370px;
  border: 1px solid #ffffffa0;
  border-radius: 50%;
  z-index: -1;
  pointer-events: none;
  animation: closing-drift 12s ease-in-out infinite alternate paused;
}
.closing[data-motion='true'] .closing-flower,
.closing[data-motion='true'] .closing-ring {
  animation-play-state: running;
}
.motion-toggle {
  margin-top: 18px;
  padding: 6px 10px;
  font-size: 11px;
  color: #62408f;
  text-decoration: underline;
  text-underline-offset: 3px;
}
/* V2-only FAQ: compact two-column grid with restrained type hierarchy. */
.faq-grid {
  display: grid;
  gap: 14px;
  margin-top: 26px;
}
.faq-item {
  border: 1px solid var(--line);
  border-radius: 14px;
  padding: 18px 20px;
  background: #fffdf7;
}
.faq-item h3 {
  font-size: 1.02rem;
  line-height: 1.35;
  margin: 0 0 8px;
}
.faq-item p {
  font-size: 0.92rem;
  line-height: 1.6;
  color: var(--muted);
  margin: 0;
}
@media (min-width: 760px) {
  .faq-grid {
    grid-template-columns: 1fr 1fr;
    gap: 16px;
  }
}
@keyframes closing-sway {
  from {
    rotate: -8deg;
  }
  to {
    rotate: 16deg;
  }
}
@keyframes closing-drift {
  from {
    transform: translate(0, 0) scale(1);
  }
  to {
    transform: translate(-20px, -14px) scale(1.04);
  }
}
.closing-ring:after {
  content: '';
  position: absolute;
  inset: 35px;
  border: 1px solid #ffffffa0;
  border-radius: 50%;
}
.scroll-progress {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 3px;
  background: var(--brand);
  transform: scaleX(0);
  transform-origin: left;
  z-index: 20;
}
.motion .reveal {
  opacity: 0;
  transform: translateY(23px);
  transition:
    opacity 0.5s,
    transform 0.65s var(--ease);
}

@keyframes marquee {
  to {
    transform: translateX(-50%);
  }
}
@keyframes sheen {
  to {
    transform: translateX(65%) rotate(-10deg);
  }
}
@media (max-width: 1000px) {
  .hero {
    gap: 30px;
  }
  .hero h1 {
    font-size: 68px;
  }
  .hero-copy > p {
    font-size: 13px;
  }
  .proposal-stack {
    inset: 48px 7% 43px;
  }
  .proposal {
    padding: 21px;
  }
  .story {
    grid-template-columns: 145px 1fr;
    gap: 25px;
  }
  .step {
    gap: 24px;
  }
  .step h3 {
    font-size: 31px;
  }
  .mock {
    padding: 21px;
  }
  .pain-heading {
    gap: 35px;
  }
  .pain-heading h2 {
    font-size: 46px;
  }
  .counter {
    font-size: 108px;
  }
  .counter-block {
    gap: 17px;
  }
  .docs-grid {
    gap: 45px;
  }
  .docs-copy h2 {
    font-size: 46px;
  }
  .trust-box {
    gap: 40px;
  }
}
@media (max-width: 760px) {
  .wrap {
    width: calc(100% - 40px);
  }
  .hero {
    grid-template-columns: 1fr;
    gap: 15px;
    padding: 32px 0 35px;
  }
  .eyebrow {
    font-size: 9px;
    letter-spacing: 0.045em;
    margin-bottom: 21px;
  }
  .hero h1 {
    font-size: clamp(48px, 12.8vw, 72px);
  }
  .hero-copy > p {
    font-size: 12px;
    line-height: 1.9;
    margin: 28px 0 24px;
  }
  .hero .accent:after {
    bottom: -7px;
    height: 9px;
    border-top-width: 2px;
  }
  .cta {
    font-size: 12px;
    padding: 13px 22px;
    min-height: 52px;
    border-radius: 15px;
  }
  .guarantee {
    font-size: 9px;
  }
  .hero-art {
    width: 100%;
    max-width: 430px;
    margin: auto;
    padding: 22px 0 10px;
  }
  .scene {
    height: 360px;
  }
  .proposal-stack {
    inset: 37px 8% 35px;
  }
  .proposal {
    padding: 19px;
    border-radius: 21px;
  }
  .proposal-head {
    padding-bottom: 11px;
  }
  .proposal h3 {
    font-size: 25px;
    margin: 18px 0 7px;
  }
  .proposal .row {
    font-size: 10px;
    padding: 10px 0;
  }
  .studio {
    font-size: 20px;
  }
  .mini-tag {
    font-size: 7px;
  }
  .total {
    padding-top: 13px;
  }
  .total strong {
    font-size: 26px;
  }
  .hero-note {
    font-size: 13px;
    top: 4px;
    left: 2px;
  }
  .hero-note span {
    font-size: 23px;
  }
  .spark {
    font-size: 51px;
    right: 0;
    top: 1px;
  }
  .orbit {
    inset: 35px 0 10px;
  }
  .scene:before {
    inset: 15px 4px 20px;
  }
  .accepted {
    font-size: 10px;
    right: 0;
    bottom: 9px;
    padding: 11px 15px;
    border-radius: 14px;
  }
  .accepted small {
    font-size: 8px;
  }
  .scene-controls {
    gap: 9px;
    margin-top: 16px;
  }
  .segmented button {
    font-size: 10px;
    padding: 7px 15px;
  }
  .scene-controls > span {
    font-size: 8px;
  }
  .chat {
    font-size: 10px;
    padding: 15px;
    top: 45px;
  }
  .chat:nth-child(2) {
    top: 141px;
    left: 20%;
    width: 77%;
  }
  .chat:nth-child(3) {
    top: 237px;
  }
  .trade-set {
    font-size: 20px;
    gap: 24px;
    padding-right: 24px;
  }
  .ribbon {
    padding: 13px 0;
  }
  .pause {
    top: 10px;
    width: 33px;
    height: 33px;
  }
  .section {
    padding: 65px 0;
  }
  .pain-heading {
    grid-template-columns: 1fr;
    gap: 23px;
  }
  .pain-heading h2 {
    font-size: 37px;
  }
  .counter-block {
    gap: 25px;
  }
  .counter {
    font-size: 86px;
  }
  .counter-block p {
    max-width: 180px;
    font-size: 11px;
  }
  .pain-grid {
    grid-template-columns: 1fr;
    gap: 13px;
    margin: 25px 0;
  }
  .pain-card {
    padding: 23px;
    border-radius: 22px;
  }
  .pain-card h3 {
    margin: 17px 0 12px;
    font-size: 31px;
  }
  .pain-card p {
    font-size: 11px;
  }
  .pain-end {
    text-align: left;
    font-size: 23px;
  }
  .flow-section {
    border-radius: 34px 34px 0 0;
  }
  .flow-heading {
    display: block;
    margin-bottom: 27px;
  }
  .flow-heading h2 {
    font-size: 41px;
    line-height: 1.12;
  }
  .flow-heading p {
    font-size: 12px;
    max-width: 290px;
    margin-top: 22px;
  }
  .story {
    display: block;
  }
  .story-nav {
    top: var(--nav-h);
    z-index: 5;
    flex-direction: row;
    gap: 5px;
    background: #ece4f6;
    margin: 0 -20px;
    padding: 10px 20px;
    border-bottom: 1px solid #d8c9e5;
  }
  .story-nav a {
    flex: 1;
    justify-content: center;
    font-size: 0;
    padding: 11px 5px;
    gap: 0;
  }
  .story-nav a span {
    font-size: 11px;
  }
  .step {
    grid-template-columns: 1fr;
    gap: 26px;
    padding: 35px 0 42px;
    scroll-margin-top: 75px;
  }
  .step:first-child {
    padding-top: 30px;
  }
  .step-num {
    margin-bottom: 18px;
  }
  .step h3 {
    font-size: 35px;
    max-width: 320px;
  }
  .step p {
    font-size: 12px;
    margin-top: 17px;
    max-width: 470px;
  }
  .mock {
    padding: 23px;
    max-width: 430px;
    width: 100%;
    margin: auto;
    border-radius: 24px;
  }
  .mock-title {
    font-size: 27px;
  }
  .mock .row {
    font-size: 10px;
  }
  .compare-heading {
    gap: 20px;
    align-items: start;
  }
  .compare-heading h2 {
    font-size: 37px;
  }
  .control-seal {
    display: none;
  }
  .compare-grid {
    grid-template-columns: 1fr;
    gap: 15px;
    margin-top: 27px;
  }
  .compare-col {
    padding: 25px;
    border-radius: 23px;
  }
  .compare-col li {
    font-size: 11px;
  }
  .docs {
    padding-top: 0;
  }
  .docs-grid {
    grid-template-columns: 1fr;
    gap: 32px;
  }
  .docs-copy h2 {
    font-size: 40px;
  }
  .docs-copy p {
    font-size: 12px;
  }
  .workbench {
    padding: 27px 23px;
    border-radius: 27px 27px 55px 27px;
  }
  .doc {
    padding: 24px;
    min-height: 335px;
  }
  .doc h3 {
    font-size: 33px;
  }
  .skin-picker {
    margin-top: 25px;
  }
  .skin-picker button {
    font-size: 9px;
    padding: 8px;
  }
  .trust {
    padding-bottom: 60px;
  }
  .trust-box {
    padding: 26px 21px;
    grid-template-columns: 1fr;
    gap: 26px;
    border-radius: 27px;
  }
  .trust h2 {
    font-size: 39px;
  }
  .trust p {
    font-size: 12px;
  }
  .trust-catalog {
    padding: 18px;
  }
  .trust-catalog .row {
    font-size: 9px;
  }
  .closing {
    padding: 65px 0;
    border-radius: 35px 35px 0 0;
  }
  .closing h2 {
    font-size: 45px;
  }
  .closing p {
    font-size: 12px;
    max-width: 305px;
  }
  .closing-flower {
    font-size: 100px;
    left: -40px;
    top: 18px;
  }
  .closing-ring {
    right: -255px;
    bottom: -190px;
  }
}
@media (prefers-reduced-motion: reduce) {
  html {
    scroll-behavior: auto;
  }
  *,
  *:before,
  *:after {
    animation: none !important;
    transition: none !important;
  }
  .motion .reveal {
    opacity: 1;
    transform: none;
  }
  .pause {
    display: none;
  }
}
.deep-link {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  margin-top: 18px;
  font-family: 'IBM Plex Mono', monospace;
  font-size: 11px;
  letter-spacing: 0.04em;
  color: var(--violet);
  font-weight: 500;
}
.deep-link:hover {
  text-decoration: underline;
}
.deep-link span {
  font-size: 14px;
}
</style>
